import React, { useEffect, useState } from 'react'
import documentServices from '../documentServices';
import moment from 'moment';
import { AccessTime, CalendarMonth} from '@mui/icons-material';

function DocumentTimeline({documentId}) {

    const [documentTimeLine,setDocumentTimeline] = useState(null);
    const getDocumentTimeline = () =>{
        documentServices.getTimeLine(documentId).then(res=>{
            setDocumentTimeline(res.data)
        }).catch(error=>{
            console.log(error.message)
        })
    }

    useEffect(()=>{
        getDocumentTimeline();
    },[documentId])

    return (
        <ul className="timeline mt-3">
            {documentTimeLine && documentTimeLine.map(log=>
                <li className="timeline-item" key={log.id}>
                    <span className='badge bg-dark'><CalendarMonth/> {moment(log.created_at).format("DD-MMM YYYY") }</span>
                    <span className='badge bg-dark ms-2'><AccessTime/> {moment(log.created_at).format("hh:ss A") }</span>
                    <div className='card border-0 mt-1'>
                        <div className='card-body'>
                            <div> <span className='fw-bold'>"{log.firstName} {log.lastName}"</span> <span className="fw-bold"> </span>{log.remark.remark}</div>
                        </div>
                    </div>
                    { log.remark.ref !== undefined &&
                        <div className='border border-secondary-subtle rounded mb-2 p-2 '>
                            {log.remark.ref === "note" && <p>{log.remark.details}</p>}
                            {log.remark.ref === "image" && <img style={{maxHeight:450}} className='img-fluid' src={log.remark.url} />}
                            {log.remark.ref === "attachment" && <embed style={{width:300,height:500}} src={log.remark.url} />}
                        </div>
                    }
                </li>
            )}

        </ul>
    )
}

export default DocumentTimeline